<template>
  <div class="exp-slider-skeleton">
    <PageWrap>
      <SkeletonItem
        class="exp-slider-skeleton__title"
        width="360px"
        height="32px"
        :border-radius="8"
        :is-animated="animated"
        ignore-global-animation
      />
    </PageWrap>

    <div class="exp-slider-skeleton__viewport">
      <div class="exp-slider-skeleton__row">
        <div
          v-for="n in 4"
          :key="n"
          class="exp-slider-skeleton__card"
        >
          <SkeletonItem
            class="exp-slider-skeleton__cover"
            width="100%"
            height="200px"
            :border-radius="8"
            :is-animated="animated"
            ignore-global-animation
          />
          <SkeletonItem
            width="55%"
            height="14px"
            :border-radius="8"
            :is-animated="animated"
            ignore-global-animation
          />
          <SkeletonItem
            width="100%"
            height="18px"
            :border-radius="8"
            :is-animated="animated"
            ignore-global-animation
          />
          <SkeletonItem
            width="80%"
            height="18px"
            :border-radius="8"
            :is-animated="animated"
            ignore-global-animation
          />
          <SkeletonItem
            class="exp-slider-skeleton__price"
            width="40%"
            height="22px"
            :border-radius="8"
            :is-animated="animated"
            ignore-global-animation
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { SkeletonItem } from '@experience/core-skeleton-lib';

  import PageWrap from '@/shared/ui/PageWrap.vue';

  withDefaults(
    defineProps<{
      animated?: boolean;
    }>(),
    {
      animated: true,
    },
  );
</script>

<style scoped lang="scss">
  .exp-slider-skeleton {
    padding-top: 40px;

    &__title {
      margin-bottom: 24px;

      @include mobile {
        width: 240px;
        height: 24px;
      }
    }

    &__viewport {
      width: 100vw;
      min-width: var(--wrap-min-width);
      max-width: var(--wrap-max-width);
      padding: 0 var(--wrap-offset);
      margin: 0 auto;

      @include tablet {
        box-sizing: border-box;
        padding: 0;
      }
    }

    &__row {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 16px;

      @include tablet {
        grid-template-columns: repeat(2, 1fr);
      }

      @include mobile {
        grid-template-columns: 1fr;
      }
    }

    &__card {
      display: flex;
      flex-direction: column;
      gap: 10px;
    }

    &__cover {
      margin-bottom: 6px;
    }

    &__price {
      margin-top: 6px;
    }

    @include mobile {
      padding-top: 32px;
    }
  }
</style>
